import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-envelopesimpleopen",
  "use": "icon-th-envelopesimpleopen-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-envelopesimpleopen\">\n<path d=\"M28.555 11.1675L16.555 3.16748C16.3907 3.05784 16.1975 2.99933 16 2.99933C15.8025 2.99933 15.6093 3.05784 15.445 3.16748L3.445 11.1675C3.30801 11.2589 3.19572 11.3827 3.11809 11.5279C3.04046 11.6731 2.99989 11.8353 3 12V25C3 25.5304 3.21071 26.0391 3.58579 26.4142C3.96086 26.7893 4.46957 27 5 27H27C27.5304 27 28.0391 26.7893 28.4142 26.4142C28.7893 26.0391 29 25.5304 29 25V12C29.0001 11.8353 28.9595 11.6731 28.8819 11.5279C28.8043 11.3827 28.692 11.2589 28.555 11.1675ZM16 5.20123L26.2388 12.0275L17.8638 18H14.1388L5.76375 12.0275L16 5.20123ZM5 25V13.9412L13.2375 19.8162C13.4071 19.9374 13.6103 20.0025 13.8188 20.0025H18.1812C18.3897 20.0025 18.5929 19.9374 18.7625 19.8162L27 13.9412V25H5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-envelopesimpleopen.svg
// module id = 90Zs
// module chunks = 84